import { FeatureDefinition } from '../entities';

export const phoneNumberOptInFeature = 'phone_number_opt_in';

export const phoneNumberOptInFeatureConfig: FeatureDefinition = {
  defaultValue: false,
};
